import { render, staticRenderFns } from "./linkedpricelistitem.vue?vue&type=template&id=5229947e&scoped=true"
import script from "./linkedpricelistitem.vue?vue&type=script&lang=ts"
export * from "./linkedpricelistitem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5229947e",
  null
  
)

export default component.exports